var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFds1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 594.41,
    height: 405.81,
    viewBox: "0 0 594.41 405.81",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Full_Stack_Developer_img",
    "data-name": "Full Stack Developer img",
    transform: "translate(-1035.59 -2458)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19995",
    "data-name": "Path 19995",
    d: "M350.173,831.034l5.088,1.82a5.034,5.034,0,0,0,5.813-1.825,52.129,52.129,0,0,1,8.665-9.556,5.036,5.036,0,0,0,1.242-5.969l-2.3-4.889a5.075,5.075,0,0,1,2.405-6.763l9.359-4.428a5.08,5.08,0,0,1,6.761,2.422l2.314,4.886a5.037,5.037,0,0,0,5.4,2.823,51.927,51.927,0,0,1,12.882-.639,5.018,5.018,0,0,0,5.09-3.345l1.823-5.086a5.076,5.076,0,0,1,6.488-3.071l9.748,3.487a5.075,5.075,0,0,1,3.072,6.487l-1.819,5.088a5.036,5.036,0,0,0,1.818,5.816,52.136,52.136,0,0,1,9.556,8.655,5.032,5.032,0,0,0,5.974,1.248l4.886-2.313a5.065,5.065,0,0,1,6.754,2.419l4.433,9.355a5.077,5.077,0,0,1-2.42,6.76l-4.885,2.312a5.024,5.024,0,0,0-2.817,5.406,52.645,52.645,0,0,1,.638,12.883,5.023,5.023,0,0,0,3.336,5.1l5.089,1.817a5.075,5.075,0,0,1,3.071,6.488l-3.485,9.747a5.08,5.08,0,0,1-6.49,3.072l-5.085-1.819a5.042,5.042,0,0,0-5.82,1.823,51.787,51.787,0,0,1-8.651,9.551,5.038,5.038,0,0,0-1.254,5.974l2.318,4.886a5.075,5.075,0,0,1-2.419,6.759l-9.349,4.43a5.086,5.086,0,0,1-6.767-2.421l-2.305-4.884a5.032,5.032,0,0,0-5.414-2.82,51.988,51.988,0,0,1-12.874.635,5.034,5.034,0,0,0-5.1,3.342l-1.818,5.086a5.07,5.07,0,0,1-6.488,3.072l-9.751-3.48a5.093,5.093,0,0,1-3.07-6.5l1.824-5.085a5.042,5.042,0,0,0-1.828-5.82,52.165,52.165,0,0,1-9.549-8.651,5.033,5.033,0,0,0-5.97-1.248l-4.884,2.314a5.083,5.083,0,0,1-6.767-2.416l-4.425-9.36a5.072,5.072,0,0,1,2.418-6.76l4.888-2.313a5.038,5.038,0,0,0,2.823-5.406,51.374,51.374,0,0,1-.64-12.88,5.023,5.023,0,0,0-3.339-5.092l-5.093-1.824a5.07,5.07,0,0,1-3.071-6.487l3.487-9.748a5.066,5.066,0,0,1,6.486-3.065m26.058,25.253a28.109,28.109,0,1,0,41.495-19.632A28.075,28.075,0,0,0,376.231,856.286Z",
    transform: "translate(752.246 1864.107)",
    fill: "#6ecbff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19996",
    "data-name": "Path 19996",
    d: "M467.556,874.665a35.288,35.288,0,1,1-22.191-15.4,35.178,35.178,0,0,1,22.191,15.4m-21.7-17.637a37.579,37.579,0,1,0,23.629,16.4A37.467,37.467,0,0,0,445.852,857.029Z",
    transform: "translate(718.639 1831.245)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19997",
    "data-name": "Path 19997",
    d: "M427.6,928.854a41.922,41.922,0,0,0,22.418,1.977c.305-.056.608-.117.91-.179l.019,1.38-.68.132a43.277,43.277,0,0,1-22.888-1.945Zm1.655-79.466a41.952,41.952,0,0,0-20.087,14.126l-.99-.934a43.306,43.306,0,0,1,20.677-14.489Zm46.183,13.907a42.263,42.263,0,0,0-9.166-8.574q-1.128-.776-2.306-1.479l.7-1.16q1.211.725,2.375,1.524a43.646,43.646,0,0,1,9.375,8.742Z",
    transform: "translate(714.247 1835.739)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19998",
    "data-name": "Path 19998",
    d: "M215.687,724.288l3.7-.174a3.454,3.454,0,0,0,3.212-2.676,35.754,35.754,0,0,1,3-8.327,3.455,3.455,0,0,0-.771-4.112l-2.739-2.5a3.483,3.483,0,0,1-.24-4.919l4.782-5.253a3.486,3.486,0,0,1,4.922-.231l2.744,2.5a3.455,3.455,0,0,0,4.167.38,35.686,35.686,0,0,1,8.007-3.771,3.442,3.442,0,0,0,2.356-3.452l-.172-3.7a3.483,3.483,0,0,1,3.314-3.644l7.1-.334a3.482,3.482,0,0,1,3.644,3.314l.175,3.7a3.456,3.456,0,0,0,2.673,3.215,35.753,35.753,0,0,1,8.324,2.995,3.454,3.454,0,0,0,4.117-.769l2.495-2.744a3.476,3.476,0,0,1,4.918-.229l5.257,4.777a3.485,3.485,0,0,1,.23,4.922l-2.5,2.743a3.45,3.45,0,0,0-.376,4.167,36.09,36.09,0,0,1,3.77,8.007,3.448,3.448,0,0,0,3.448,2.361l3.7-.177a3.482,3.482,0,0,1,3.644,3.314l.334,7.095a3.486,3.486,0,0,1-3.315,3.645l-3.7.175a3.458,3.458,0,0,0-3.216,2.677,35.557,35.557,0,0,1-2.994,8.32,3.457,3.457,0,0,0,.765,4.118l2.747,2.495a3.482,3.482,0,0,1,.231,4.92l-4.775,5.253a3.489,3.489,0,0,1-4.926.232l-2.739-2.5a3.454,3.454,0,0,0-4.171-.375,35.656,35.656,0,0,1-8,3.766,3.452,3.452,0,0,0-2.364,3.453l.175,3.7a3.479,3.479,0,0,1-3.314,3.644l-7.1.337a3.493,3.493,0,0,1-3.645-3.318l-.171-3.7a3.461,3.461,0,0,0-2.68-3.216,35.812,35.812,0,0,1-8.319-2.994,3.454,3.454,0,0,0-4.115.768l-2.494,2.743a3.488,3.488,0,0,1-4.925.236l-5.253-4.783a3.48,3.48,0,0,1-.232-4.92l2.5-2.745a3.458,3.458,0,0,0,.379-4.168,35.234,35.234,0,0,1-3.771-8,3.447,3.447,0,0,0-3.449-2.359l-3.707.173a3.48,3.48,0,0,1-3.643-3.314l-.334-7.1a3.477,3.477,0,0,1,3.314-3.64m23.131,9.216a19.287,19.287,0,1,0,21.2-23.3A19.264,19.264,0,0,0,238.818,733.5Z",
    transform: "translate(823.222 1927.025)",
    fill: "#6ecbff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19999",
    "data-name": "Path 19999",
    d: "M303.241,739.841a24.586,24.586,0,1,1-15.463-10.73,24.508,24.508,0,0,1,15.463,10.73m-15.123-12.289a26.182,26.182,0,1,0,16.464,11.423A26.11,26.11,0,0,0,288.118,727.552Z",
    transform: "translate(798.732 1903.156)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20000",
    "data-name": "Path 20000",
    d: "M275.4,777.595a29.206,29.206,0,0,0,15.62,1.377c.212-.039.423-.081.633-.125l.013.963-.474.091a30.148,30.148,0,0,1-15.947-1.355Zm1.153-55.368a29.235,29.235,0,0,0-14,9.843l-.69-.651a30.178,30.178,0,0,1,14.406-10.1Zm32.177,9.691a29.415,29.415,0,0,0-6.386-5.973q-.786-.541-1.607-1.031l.489-.808q.845.5,1.654,1.062a30.375,30.375,0,0,1,6.532,6.091Z",
    transform: "translate(795.672 1906.288)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20001",
    "data-name": "Path 20001",
    d: "M414.8,1244.025H916.017a2.2,2.2,0,0,1,2.2,2.2h0a2.2,2.2,0,0,1-2.2,2.2H414.8a2.2,2.2,0,0,1-2.2-2.2h0a2.2,2.2,0,0,1,2.2-2.2",
    transform: "translate(711.785 1615.39)",
    fill: "#1f3445",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20002",
    "data-name": "Path 20002",
    d: "M624.9,612.876H937.023a20.4,20.4,0,0,1,20.342,20.342V815.144H604.558V633.218A20.4,20.4,0,0,1,624.9,612.876",
    transform: "translate(604.957 1966.643)",
    fill: "#99bbeb",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20003",
    "data-name": "Path 20003",
    d: "M637.554,646.685H960.7a.356.356,0,0,1,.356.355V852.323a.357.357,0,0,1-.356.356H637.554a.357.357,0,0,1-.356-.356V647.04a.356.356,0,0,1,.356-.355",
    transform: "translate(586.792 1947.827)",
    fill: "#e8f5fc",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20004",
    "data-name": "Path 20004",
    d: "M900.5,1134.907c-1.433,25.906-5.224,32.457-31.494,47.219H985.463c-26.27-14.762-30.061-21.313-31.494-47.219l-26.733-2.105Z",
    transform: "translate(457.783 1677.289)",
    fill: "#99bbeb",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20005",
    "data-name": "Path 20005",
    d: "M957.365,1068.979v13.369a20.4,20.4,0,0,1-20.342,20.342H624.9a20.4,20.4,0,0,1-20.343-20.342v-13.369Z",
    transform: "translate(604.957 1712.808)",
    fill: "#7da8e5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2890",
    "data-name": "Rectangle 2890",
    width: 352.807,
    height: 21.372,
    transform: "translate(1209.515 2768.606)",
    fill: "#99bbeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20006",
    "data-name": "Path 20006",
    d: "M963.851,1099.97a3.623,3.623,0,1,1-3.623,3.623,3.623,3.623,0,0,1,3.623-3.623",
    transform: "translate(407.016 1695.561)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20007",
    "data-name": "Path 20007",
    d: "M994.095,1099.97a3.623,3.623,0,1,1-3.623,3.623,3.623,3.623,0,0,1,3.623-3.623",
    transform: "translate(390.185 1695.561)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20008",
    "data-name": "Path 20008",
    d: "M1024.337,1099.97a3.623,3.623,0,1,1-3.623,3.623,3.622,3.622,0,0,1,3.623-3.623",
    transform: "translate(373.354 1695.561)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2891",
    "data-name": "Rectangle 2891",
    width: 92.826,
    height: 143.476,
    transform: "translate(1234.033 2615.511)",
    fill: "#0094c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20009",
    "data-name": "Path 20009",
    d: "M672.226,955.28h58.989a2.4,2.4,0,1,1,0,4.8H672.226a2.4,2.4,0,0,1,0-4.8",
    transform: "translate(568.634 1776.085)",
    fill: "#b1deff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20010",
    "data-name": "Path 20010",
    d: "M672.227,710.364h21.948a2.4,2.4,0,1,1,0,4.8H672.227a2.4,2.4,0,0,1,0-4.8",
    transform: "translate(568.634 1912.388)",
    fill: "#b1deff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20011",
    "data-name": "Path 20011",
    d: "M672.227,740.953h73.314a2.4,2.4,0,1,1,0,4.8H672.227a2.4,2.4,0,0,1,0-4.8",
    transform: "translate(568.634 1895.364)",
    fill: "#b1deff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20012",
    "data-name": "Path 20012",
    d: "M672.227,770.167h73.314a2.4,2.4,0,1,1,0,4.8H672.227a2.4,2.4,0,1,1,0-4.8",
    transform: "translate(568.634 1879.106)",
    fill: "#b1deff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20013",
    "data-name": "Path 20013",
    d: "M672.227,799.38h19.967a2.4,2.4,0,1,1,0,4.8H672.227a2.4,2.4,0,0,1,0-4.8",
    transform: "translate(568.634 1862.848)",
    fill: "#b1deff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20014",
    "data-name": "Path 20014",
    d: "M736.155,799.38h19.967a2.4,2.4,0,0,1,0,4.8H736.155a2.4,2.4,0,1,1,0-4.8",
    transform: "translate(533.056 1862.848)",
    fill: "#b1deff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20015",
    "data-name": "Path 20015",
    d: "M672.227,834.709h26.861a2.4,2.4,0,0,1,0,4.8H672.227a2.4,2.4,0,0,1,0-4.8",
    transform: "translate(568.634 1843.186)",
    fill: "#b1deff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20016",
    "data-name": "Path 20016",
    d: "M753.948,834.709h26.861a2.4,2.4,0,0,1,0,4.8H753.948a2.4,2.4,0,0,1,0-4.8",
    transform: "translate(523.153 1843.186)",
    fill: "#b1deff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20017",
    "data-name": "Path 20017",
    d: "M672.227,861.175H704.7a2.4,2.4,0,1,1,0,4.8H672.227a2.4,2.4,0,0,1,0-4.8",
    transform: "translate(568.634 1828.457)",
    fill: "#b1deff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20018",
    "data-name": "Path 20018",
    d: "M768.44,861.175h32.475a2.4,2.4,0,1,1,0,4.8H768.44a2.4,2.4,0,0,1,0-4.8",
    transform: "translate(515.088 1828.457)",
    fill: "#b1deff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20019",
    "data-name": "Path 20019",
    d: "M672.227,891.118h21.948a2.4,2.4,0,1,1,0,4.8H672.227a2.4,2.4,0,0,1,0-4.8",
    transform: "translate(568.634 1811.793)",
    fill: "#b1deff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20020",
    "data-name": "Path 20020",
    d: "M672.227,925.722H704.7a2.4,2.4,0,1,1,0,4.8H672.227a2.4,2.4,0,0,1,0-4.8",
    transform: "translate(568.634 1792.535)",
    fill: "#0094ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20021",
    "data-name": "Path 20021",
    d: "M768.44,925.722h32.475a2.4,2.4,0,1,1,0,4.8H768.44a2.4,2.4,0,1,1,0-4.8",
    transform: "translate(515.088 1792.535)",
    fill: "#b1deff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20022",
    "data-name": "Path 20022",
    d: "M978.05,667.982H718.792a2.375,2.375,0,0,0-1.667.679,2.259,2.259,0,0,0,0,3.259,2.375,2.375,0,0,0,1.667.679H978.05a2.376,2.376,0,0,0,1.666-.679,2.26,2.26,0,0,0,0-3.259,2.377,2.377,0,0,0-1.666-.679m-259.258-.864H978.05a3.278,3.278,0,0,1,2.291.931,3.115,3.115,0,0,1,0,4.483,3.277,3.277,0,0,1-2.291.931H718.792a3.275,3.275,0,0,1-2.292-.931,3.115,3.115,0,0,1,0-4.483A3.277,3.277,0,0,1,718.792,667.118Z",
    transform: "translate(543.188 1936.456)",
    fill: "#0094ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2892",
    "data-name": "Rectangle 2892",
    width: 7.173,
    height: 6.793,
    transform: "translate(1245.074 2603.351)",
    fill: "#0094ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2893",
    "data-name": "Rectangle 2893",
    width: 6.974,
    height: 6.793,
    transform: "translate(1234.033 2603.351)",
    fill: "#0094ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2894",
    "data-name": "Rectangle 2894",
    width: 55.335,
    height: 7.368,
    transform: "translate(1357.128 2815.499)",
    fill: "#7da8e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20023",
    "data-name": "Path 20023",
    d: "M820.98,481.1c-11.475,0-20.777,9.1-20.777,18.677s6.827,16.24,16,18.181h25.556V499.776c0-10.315-9.3-18.677-20.776-18.677",
    transform: "translate(496.075 2039.98)",
    fill: "#04769b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20024",
    "data-name": "Path 20024",
    d: "M846.575,481.1h0Zm20.989,46.626h-.072v200.9h198.969V499.776c0-10.316-9.3-18.677-20.777-18.677h-198.9c11.475,0,20.776,8.362,20.776,18.677Z",
    transform: "translate(470.268 2039.98)",
    fill: "#0094c4",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20025",
    "data-name": "Path 20025",
    d: "M427.129,599.244c5.966,7.459,12.155,17.54,14.4,24.82a2.321,2.321,0,0,0,1.259,1.39l19.483-.521a2.73,2.73,0,0,0,1.691-1.787c1.769-7.039,15.4-28.995,15.227-28.93a31.008,31.008,0,0,0,3.931-16,31.709,31.709,0,0,0-63.391,1.694,31,31,0,0,0,4.739,15.7c.942,1.226,1.62,2.41,2.658,3.631",
    transform: "translate(707.824 2002.926)",
    fill: "#f9c201",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20026",
    "data-name": "Path 20026",
    d: "M470.2,647.8c-.569-4.76-3.925-4.768-4.265-1.346a5.377,5.377,0,0,0,.311,2.255c.279.811,1.851,1.369,4.024,1.691Zm12.42-.332c.314-4.785,3.664-4.97,4.188-1.572a5.387,5.387,0,0,1-.191,2.269c-.236.823-1.776,1.464-3.927,1.9Zm-5.673,5.772-.387.008-.387.012v-.007a35.159,35.159,0,0,1-3.666-.164l.021.779.626,23.434-2.163.058-.627-23.434-.03-1.134c-3.1-.562-5.489-1.635-6.046-3.257a7.95,7.95,0,0,1-.44-3.349,5.965,5.965,0,0,1,.977-2.773,5.043,5.043,0,0,1,1.916-1.693c3.345-.9,5.744,2.614,5.622,5.982l.079,2.932c1.279.093,2.662.124,4.052.1,1.39-.048,2.768-.154,4.041-.315l-.078-2.931c-.3-3.357,1.907-6.99,5.295-6.275a5.057,5.057,0,0,1,2,1.589,5.966,5.966,0,0,1,1.123,2.717,7.954,7.954,0,0,1-.26,3.366c-.47,1.651-2.8,2.85-5.864,3.576l.031,1.135.626,23.434-2.163.057-.627-23.433-.02-.78a35.127,35.127,0,0,1-3.652.36Z",
    transform: "translate(683.285 1950.924)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20027",
    "data-name": "Path 20027",
    d: "M471.261,722.334l15.233-.407a3.91,3.91,0,0,1,4,3.794h0a3.941,3.941,0,0,1-3.794,4l-.566.015a.456.456,0,0,0,.023.885c1.325-.036,2.04,1.031,2.047,2.354h0a2.434,2.434,0,0,1-2.343,2.472l-1.318.035a.456.456,0,0,0,.023.885,2.678,2.678,0,0,1,1.5,2.239h0a2.312,2.312,0,0,1-2.243,2.367l-8.889.237a2.312,2.312,0,0,1-2.366-2.244h0a2.313,2.313,0,0,1,1.932-2.336.464.464,0,0,0-.039-.879l-1.847.05a2.415,2.415,0,0,1-2.472-2.343h0a2.415,2.415,0,0,1,2.344-2.471.464.464,0,0,0-.024-.885l-1,.026a3.91,3.91,0,0,1-4-3.794h0a3.91,3.91,0,0,1,3.795-4",
    transform: "translate(681.253 1905.953)",
    fill: "#0094c4",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20028",
    "data-name": "Path 20028",
    d: "M505.12,563.617a3.1,3.1,0,0,0-2.419,5.7,23.859,23.859,0,0,1,9.839,8.3,25.667,25.667,0,0,1,4.719,12.421,3.1,3.1,0,0,0,6.179-.483,31.978,31.978,0,0,0-5.833-15.507,30.094,30.094,0,0,0-12.485-10.431",
    transform: "translate(662.693 1994.194)",
    fill: "#ffcf74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20029",
    "data-name": "Path 20029",
    d: "M451.263,508.753h0a1.783,1.783,0,0,1,.65,2.429l-3.884,6.728a1.782,1.782,0,0,1-2.429.651h0a1.782,1.782,0,0,1-.651-2.428l3.884-6.728a1.784,1.784,0,0,1,2.429-.651m-52.926,0h0a1.784,1.784,0,0,1,2.428.651l3.884,6.728A1.782,1.782,0,0,1,404,518.56h0a1.783,1.783,0,0,1-2.43-.651l-3.884-6.728A1.784,1.784,0,0,1,398.338,508.753Zm-19.372,19.372h0a1.784,1.784,0,0,1,2.428-.651l6.727,3.884a1.784,1.784,0,0,1,.651,2.429h0a1.783,1.783,0,0,1-2.429.651l-6.728-3.884A1.784,1.784,0,0,1,378.966,528.124Zm91.67,0h0a1.783,1.783,0,0,1-.651,2.429l-6.728,3.884a1.782,1.782,0,0,1-2.428-.651h0a1.785,1.785,0,0,1,.651-2.429l6.728-3.884A1.784,1.784,0,0,1,470.635,528.124Zm7.091,26.463h0a1.785,1.785,0,0,1-1.778,1.779H468.18a1.784,1.784,0,0,1-1.778-1.779h0a1.784,1.784,0,0,1,1.778-1.778h7.768A1.784,1.784,0,0,1,477.726,554.588Zm-94.527,0h0a1.784,1.784,0,0,1-1.778,1.779h-7.768a1.784,1.784,0,0,1-1.778-1.779h0a1.783,1.783,0,0,1,1.778-1.778h7.768A1.784,1.784,0,0,1,383.2,554.588Zm41.6-52.925h0a1.783,1.783,0,0,1,1.778,1.777v7.768a1.783,1.783,0,0,1-1.778,1.778h0a1.783,1.783,0,0,1-1.778-1.778V503.44A1.783,1.783,0,0,1,424.8,501.663Z",
    transform: "translate(734.452 2028.536)",
    fill: "#f9c201",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20030",
    "data-name": "Path 20030",
    d: "M1322.814,744.691h46.066a18.9,18.9,0,0,1,18.9,18.894v12.583a18.894,18.894,0,0,1-18.9,18.892h-35.994l-10.073,9.268V795.06a18.893,18.893,0,0,1-18.895-18.892V763.585a18.894,18.894,0,0,1,18.895-18.894",
    transform: "translate(215.742 1893.284)",
    fill: "#f9c201",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20031",
    "data-name": "Path 20031",
    d: "M628.3,1224.558H609.544a1.736,1.736,0,0,1-1.721-1.5,1.715,1.715,0,0,1-.011-.365l.762-9.852a10.986,10.986,0,0,1,1.874-.619,1.9,1.9,0,0,0,1.391-1.262c.014-.047.026-.094.038-.143.431-1.9,3.164-2.5,3.669-.646.066.239.122.473.171.7.012.054.024.111.034.165.081.4.14.766.181,1.086l0,.021a10.515,10.515,0,0,1,.093,1.339q.373.472.72.93c.119.153.233.3.347.452.246.32.486.633.722.932.109.141.217.278.326.412.26.326.517.634.773.922.116.13.231.258.35.381a5.4,5.4,0,0,0,3.1,1.872c2.034.279,5.356.5,6.962,3.488a1.106,1.106,0,0,1,.081.19,1.157,1.157,0,0,1-1.1,1.5",
    transform: "translate(603.149 1634.857)",
    fill: "#630"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20032",
    "data-name": "Path 20032",
    d: "M628.321,1242.136H609.564a1.737,1.737,0,0,1-1.721-1.505h21.582a1.158,1.158,0,0,1-1.1,1.505",
    transform: "translate(603.129 1617.279)",
    fill: "#000446"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20033",
    "data-name": "Path 20033",
    d: "M622.114,967.669c2.64,5.86,5.92,11.335,13.478,12.474,6.13.923,28.063-9.6,28.883-15.113s-2.934-6.407-2.934-6.407-21.621,9.954-23.257,9.408c-1.235-.41-7.239-6.086-10.927-9.455-.785-.717-6.379,6.571-5.242,9.093",
    transform: "translate(595.271 1774.278)",
    fill: "#000446",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20034",
    "data-name": "Path 20034",
    d: "M583.823,952.327H569.488c-3.468,0-8.465,1.738-10.564,4.2-3.008,3.523-1.835,42.932-.917,48.423l1.051.746c0,21.951-3.169,45.19-2.063,66.185l8.669.107,11.049-54.526,5.276-11.552,9.015-.725,2.444-.326-2.378-49.73a11.227,11.227,0,0,0-7.247-2.8",
    transform: "translate(631.557 1777.729)",
    fill: "#000446",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20035",
    "data-name": "Path 20035",
    d: "M556.752,968.137c1.42-2.954.328-8.737-2.679-10.035a5.141,5.141,0,0,0-3.991-.3c-9.337,4.052-14.229,40.332-12.677,42.863,1.348,2.2,1.23,7.665,6.5,5.828,3.223-1.123,6.922-26.023,12.85-38.355",
    transform: "translate(642.488 1774.846)",
    fill: "#000446",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20036",
    "data-name": "Path 20036",
    d: "M600.967,952.228c.948,7.119-2.463,19.874-3.285,27.657-.249-.612-6.921-22.169-7.57-27.657h6.475a35.961,35.961,0,0,1,4.38,0",
    transform: "translate(612.997 1777.828)",
    fill: "#b6e0fc",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20037",
    "data-name": "Path 20037",
    d: "M605.046,924.692c.5,3.343-3.334,5.891-5.939,5.668v1.528l.134.191c.91,2.365-1.651,3.885-2.5,4.7-.777-.6-4.929-1.725-5.023-5h.168V926.03a2.51,2.51,0,0,1-.573-.252,2.005,2.005,0,0,1-.644-2.086c.153-.882,1.377-.286,1.377-.286h0c-1.062-2.614-2.422-4.869.315-6.322s8.26-1.344,8.26-1.344l3.311-.342c-.9,1.423.783,7.078,1.116,9.293",
    transform: "translate(612.715 1798.28)",
    fill: "#f7cccf",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20038",
    "data-name": "Path 20038",
    d: "M598.725,943.379c1.164,3.118,2.269,4.276,4.894,4.633v-2.123a9.159,9.159,0,0,1-4.894-2.51",
    transform: "translate(608.203 1782.708)",
    fill: "#ed8082",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20039",
    "data-name": "Path 20039",
    d: "M615.124,1071.063,597.9,1071l3.145,67.144,10.894.354Z",
    transform: "translate(608.66 1711.685)",
    fill: "#000446",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20040",
    "data-name": "Path 20040",
    d: "M568.1,1226.9c-.159,2.805-10.1,1.839-11.694,1a1.917,1.917,0,0,1-.919-1.711,11.942,11.942,0,0,1,.765-3.974c.637-1.976.549-1.94.991-3.29,0,0-.114-2.2,3.144-3.036s4.454,4.63,5.01,5.682c.51.964,2.49,2.283,2.695,4.656a4.67,4.67,0,0,1,.009.676",
    transform: "translate(632.27 1631.098)",
    fill: "#630"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20041",
    "data-name": "Path 20041",
    d: "M567.986,1241.152c-.2,1.821-9.976,1.639-11.567.8-.614-.324-.871-1.536-.919-2.294a12.928,12.928,0,0,0,5.636,1.225,15.29,15.29,0,0,0,6.968-1.187c.019.216-.105,1.227-.118,1.46",
    transform: "translate(632.259 1617.823)",
    fill: "#000446"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20042",
    "data-name": "Path 20042",
    d: "M600.889,897.068c.7,3.562-.73,6.745-4.234,7.329-2.609.436-7.157-.094-9.192,1.817-1.008.946-1,2.162-.268,4.608.215.718.549,1.269-.55.6-.5-.307-1.343-.751-1.67-.542a1.388,1.388,0,0,0-.029,2.058c.219.19.641.483.641.483a3.254,3.254,0,0,1-2.685-.674c-1.284-1.036-5.031-4.17-4.292-8.672,1.076-6.559,3.79-6.354,9.568-8.32,3.336-1.136,3.609-2.02,5.745-3,2.742-1.255,6.412,1.5,6.966,4.311",
    transform: "translate(619.451 1811.055)",
    fill: "#000446",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20043",
    "data-name": "Path 20043",
    d: "M512.4,913.417a5.11,5.11,0,1,1-6.959-1.949,5.11,5.11,0,0,1,6.959,1.949m143.335-63.775c3.228,3.777-2.521,16.832-11.292,22.467-5.247,3.371-11.1,6.336-15.482,6.737-7.82.716-17.82-1.76-22.3-3.033l-79.19,44.538L517.1,926.187l-2.526,1.421c-6.582,3.7-14.51,1.046-18.7-5.237h0c-4.189-6.284-1.345-15,5.237-18.7l2.526-1.421,10.377-5.836,78.815-44.328c1.044-4.279,4-14.994,8.721-21.5,2.061-2.84,6.062-5.582,10.426-7.957,11.532-6.276,27.306-4.549,28.994.026l-9.259,5.209-8.63,4.853-6.445,3.625-.544,9.131-.544,9.131,8.085,4.276,8.085,4.276,6.445-3.625,8.631-4.853Z",
    transform: "translate(666.54 1852.183)",
    fill: "#f18e00",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20044",
    "data-name": "Path 20044",
    d: "M536.783,1057.64a1.154,1.154,0,0,1,.7-.555c.109,0,1.665.077,1.665.077l-.24-3.567a.9.9,0,0,1,1.1.568,20.381,20.381,0,0,0,1.23,2.348l-.41-3.185a.645.645,0,0,1,.841.24c.3.5,1.146,2.319,1.146,2.319l.078-2.97a5.832,5.832,0,0,1,.846,1.744,7.213,7.213,0,0,0,.378,1.25l.51-2.5s.56,2.428.561,2.513c.028,2.655-1.286,4.2-3.616,4.22-.72.008-4.969-2.118-4.789-2.5",
    transform: "translate(642.679 1721.749)",
    fill: "#f7cccf",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20045",
    "data-name": "Path 20045",
    d: "M707.573,954.863a1.365,1.365,0,0,0-.927.51c-.051.118-.681,1.853-.681,1.853l-3.784-1.9a1.067,1.067,0,0,0,.114,1.462,23.985,23.985,0,0,1,2,2.421l-3.288-1.911a.763.763,0,0,0-.124,1.028c.412.558,2.006,2.317,2.006,2.317l-3.279-1.279a6.9,6.9,0,0,0,1.515,1.725,8.569,8.569,0,0,1,1.19.986l-2.963-.592s2.393,1.728,2.486,1.769c2.885,1.249,5.17.522,6.267-2.01.339-.781-.03-6.4-.531-6.376",
    transform: "translate(552.202 1776.317)",
    fill: "#f7cccf",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13713",
    "data-name": "Group 13713",
    transform: "translate(1534.496 2653.401)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20046",
    "data-name": "Path 20046",
    d: "M1354.322,798.265l-16.952-7.371v-4.081l16.952-7.337v4.807L1342.5,788.8l11.824,4.688Z",
    transform: "translate(-1337.37 -779.476)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_13714",
    "data-name": "Group 13714",
    transform: "translate(1556.867 2649.858)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20047",
    "data-name": "Path 20047",
    d: "M1387.816,797.058l6.123-25.571h3.559l-6.19,25.571Z",
    transform: "translate(-1387.816 -771.487)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_13715",
    "data-name": "Group 13715",
    transform: "translate(1571.968 2653.435)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20048",
    "data-name": "Path 20048",
    d: "M1421.866,798.324v-4.773l11.841-4.656-11.841-4.6v-4.739l16.969,7.337v4.047Z",
    transform: "translate(-1421.866 -779.552)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_20049",
    "data-name": "Path 20049",
    d: "M966.441,533.194v-3.672l9.116-3.6-9.116-3.561v-3.646l13.068,5.66V527.5ZM954.8,535.671l4.737-19.7h2.741l-4.763,19.7Zm-4.165-2.5L937.57,527.49v-3.144l13.068-5.656v3.7l-9.115,3.486,9.115,3.62Z",
    transform: "translate(419.626 2020.571)",
    fill: "#b1deff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20050",
    "data-name": "Path 20050",
    d: "M958.819,591.966h29.734a1.762,1.762,0,0,1,0,3.523H958.819a1.762,1.762,0,0,1,0-3.523",
    transform: "translate(408.781 1978.28)",
    fill: "#b1deff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20051",
    "data-name": "Path 20051",
    d: "M1045.227,591.966h16.356a1.762,1.762,0,0,1,0,3.523h-16.356a1.762,1.762,0,0,1,0-3.523",
    transform: "translate(360.692 1978.28)",
    fill: "#b1deff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20052",
    "data-name": "Path 20052",
    d: "M980.975,618.557H1014.6a1.762,1.762,0,0,1,0,3.523H980.975a1.762,1.762,0,0,1,0-3.523",
    transform: "translate(396.45 1963.481)",
    fill: "#b1deff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20053",
    "data-name": "Path 20053",
    d: "M1077.482,618.557h18.678a1.762,1.762,0,1,1,0,3.523h-18.678a1.762,1.762,0,0,1,0-3.523",
    transform: "translate(342.741 1963.481)",
    fill: "#b1deff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20054",
    "data-name": "Path 20054",
    d: "M1140.883,618.557H1164.1a1.762,1.762,0,1,1,0,3.523h-23.212a1.762,1.762,0,0,1,0-3.523",
    transform: "translate(307.457 1963.481)",
    fill: "#b1deff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20055",
    "data-name": "Path 20055",
    d: "M980.975,646.517h44.7a1.762,1.762,0,0,1,0,3.523h-44.7a1.762,1.762,0,0,1,0-3.523",
    transform: "translate(396.45 1947.921)",
    fill: "#b1deff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20056",
    "data-name": "Path 20056",
    d: "M1102.322,646.517h21.419a1.762,1.762,0,1,1,0,3.523h-21.419a1.762,1.762,0,0,1,0-3.523",
    transform: "translate(328.917 1947.921)",
    fill: "#b1deff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20057",
    "data-name": "Path 20057",
    d: "M1169.813,646.517h35.174a1.762,1.762,0,1,1,0,3.523h-35.174a1.762,1.762,0,0,1,0-3.523",
    transform: "translate(291.356 1947.921)",
    fill: "#b1deff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20058",
    "data-name": "Path 20058",
    d: "M980.975,673.872h16.733a1.761,1.761,0,1,1,0,3.522H980.975a1.761,1.761,0,1,1,0-3.522",
    transform: "translate(396.45 1932.697)",
    fill: "#b1deff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20059",
    "data-name": "Path 20059",
    d: "M1037.217,673.872h59.512a1.761,1.761,0,0,1,0,3.522h-59.512a1.761,1.761,0,1,1,0-3.522",
    transform: "translate(365.15 1932.697)",
    fill: "#b1deff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20060",
    "data-name": "Path 20060",
    d: "M980.975,700.3h44.7a1.761,1.761,0,0,1,0,3.523h-44.7a1.761,1.761,0,1,1,0-3.523",
    transform: "translate(396.45 1917.987)",
    fill: "#b1deff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20061",
    "data-name": "Path 20061",
    d: "M1102.322,700.3h21.419a1.761,1.761,0,1,1,0,3.523h-21.419a1.761,1.761,0,0,1,0-3.523",
    transform: "translate(328.917 1917.987)",
    fill: "#b1deff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20062",
    "data-name": "Path 20062",
    d: "M1169.813,700.3h35.174a1.761,1.761,0,1,1,0,3.523h-35.174a1.761,1.761,0,0,1,0-3.523",
    transform: "translate(291.356 1917.987)",
    fill: "#b1deff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20063",
    "data-name": "Path 20063",
    d: "M980.975,728.114h44.7a1.761,1.761,0,1,1,0,3.523h-44.7a1.761,1.761,0,1,1,0-3.523",
    transform: "translate(396.45 1902.51)",
    fill: "#b1deff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20064",
    "data-name": "Path 20064",
    d: "M1102.322,728.114h21.419a1.761,1.761,0,1,1,0,3.523h-21.419a1.761,1.761,0,1,1,0-3.523",
    transform: "translate(328.917 1902.51)",
    fill: "#b1deff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20065",
    "data-name": "Path 20065",
    d: "M958.819,754.393h35.909a1.761,1.761,0,1,1,0,3.523H958.819a1.761,1.761,0,1,1,0-3.523",
    transform: "translate(408.781 1887.885)",
    fill: "#b1deff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20066",
    "data-name": "Path 20066",
    d: "M1061.273,754.393h20.047a1.761,1.761,0,1,1,0,3.523h-20.047a1.761,1.761,0,0,1,0-3.523",
    transform: "translate(351.762 1887.885)",
    fill: "#b1deff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20067",
    "data-name": "Path 20067",
    d: "M980.975,786.935h49.188a1.762,1.762,0,0,1,0,3.523H980.975a1.762,1.762,0,1,1,0-3.523",
    transform: "translate(396.45 1869.774)",
    fill: "#b1deff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20068",
    "data-name": "Path 20068",
    d: "M1113.62,786.935h23.74a1.762,1.762,0,1,1,0,3.523h-23.74a1.762,1.762,0,1,1,0-3.523",
    transform: "translate(322.63 1869.774)",
    fill: "#b1deff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20069",
    "data-name": "Path 20069",
    d: "M980.975,815.052H1026a1.761,1.761,0,0,1,0,3.523H980.975a1.761,1.761,0,1,1,0-3.523",
    transform: "translate(396.45 1854.126)",
    fill: "#b1deff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20070",
    "data-name": "Path 20070",
    d: "M1103.138,815.052h21.587a1.761,1.761,0,1,1,0,3.523h-21.587a1.761,1.761,0,1,1,0-3.523",
    transform: "translate(328.463 1854.126)",
    fill: "#b1deff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20071",
    "data-name": "Path 20071",
    d: "M980.975,841.944h15.451a1.762,1.762,0,0,1,0,3.524H980.975a1.762,1.762,0,0,1,0-3.524",
    transform: "translate(396.45 1839.16)",
    fill: "#b1deff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20072",
    "data-name": "Path 20072",
    d: "M1034.65,841.944h60.729a1.762,1.762,0,0,1,0,3.524H1034.65a1.762,1.762,0,0,1,0-3.524",
    transform: "translate(366.579 1839.16)",
    fill: "#b1deff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20073",
    "data-name": "Path 20073",
    d: "M980.976,869.45h38.452a1.762,1.762,0,1,1,0,3.523H980.976a1.762,1.762,0,1,1,0-3.523",
    transform: "translate(396.45 1823.852)",
    fill: "#b1deff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20074",
    "data-name": "Path 20074",
    d: "M1086.6,869.45h18.188a1.762,1.762,0,1,1,0,3.523H1086.6a1.762,1.762,0,1,1,0-3.523",
    transform: "translate(337.665 1823.852)",
    fill: "#b1deff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20075",
    "data-name": "Path 20075",
    d: "M1147.96,869.45H1192.9a1.762,1.762,0,0,1,0,3.523H1147.96a1.762,1.762,0,0,1,0-3.523",
    transform: "translate(303.518 1823.852)",
    fill: "#b1deff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20076",
    "data-name": "Path 20076",
    d: "M980.975,895.425h15.451a1.762,1.762,0,0,1,0,3.523H980.975a1.762,1.762,0,0,1,0-3.523",
    transform: "translate(396.45 1809.396)",
    fill: "#b1deff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20077",
    "data-name": "Path 20077",
    d: "M1034.65,895.425h60.729a1.762,1.762,0,1,1,0,3.523H1034.65a1.762,1.762,0,1,1,0-3.523",
    transform: "translate(366.579 1809.396)",
    fill: "#b1deff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20078",
    "data-name": "Path 20078",
    d: "M958.819,923.8h35.909a1.761,1.761,0,1,1,0,3.523H958.819a1.761,1.761,0,1,1,0-3.523",
    transform: "translate(408.781 1793.602)",
    fill: "#b1deff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20079",
    "data-name": "Path 20079",
    d: "M1061.273,923.8h20.047a1.761,1.761,0,1,1,0,3.523h-20.047a1.761,1.761,0,0,1,0-3.523",
    transform: "translate(351.762 1793.602)",
    fill: "#b1deff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20080",
    "data-name": "Path 20080",
    d: "M966.441,979.5v-3.672l9.116-3.6-9.116-3.563v-3.646l13.068,5.661V973.8ZM954.8,981.972l4.737-19.7h2.741l-4.763,19.7Zm-4.165-2.5-13.068-5.677v-3.145l13.068-5.656v3.7l-9.115,3.487,9.115,3.62Z",
    transform: "translate(419.626 1772.191)",
    fill: "#b1deff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20081",
    "data-name": "Path 20081",
    d: "M1275.646,923.649h18.44c2.3,0,7.968,4.357,8.963,10.039h0c1.875,9.141,1.041,29.257-5.434,36.43l-7.339-.1-22.485-5.575V926.492a12.248,12.248,0,0,1,7.855-2.843",
    transform: "translate(235.849 1793.689)",
    fill: "#f29900",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20082",
    "data-name": "Path 20082",
    d: "M1327.083,923.785c9.1.895,9.952,12.335,9.834,19.477h-9.829Z",
    transform: "translate(202.851 1793.613)",
    fill: "#f29900",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20083",
    "data-name": "Path 20083",
    d: "M1299.856,967.773l8.941-.07c-3.529,9.658-10.276,17.87-19.223,17.87h-13.019s2.767-3.547,6.415-3.844,3.79.206,3.79.206c3.05-1.607,10.1-7.04,13.1-14.162",
    transform: "translate(230.971 1769.171)",
    fill: "#f7cccf",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20084",
    "data-name": "Path 20084",
    d: "M1345.136,1132.9l.892,6.414,2.292,2.12s1.786-.085,1.994.537a5.736,5.736,0,0,1,0,1.946h-11.728a53.182,53.182,0,0,1-1.354-10.649Z",
    transform: "translate(197.203 1677.234)",
    fill: "#630"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20085",
    "data-name": "Path 20085",
    d: "M1225.872,1008h38.962a6.962,6.962,0,0,1,1.294.122h0c10.875-.057,12.226,6.985,12.991,14.659l4.388,44.09h-14.766l-4.87-44.876h-38a7,7,0,1,1,0-13.995",
    transform: "translate(263.072 1746.746)",
    fill: "#092978",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20086",
    "data-name": "Path 20086",
    d: "M1258.648,1097.089l5.35,11.977a9.667,9.667,0,0,1-1.249,3.4c-.9,1.235-.981,2.138-.421,2.882s.712.929.712.929l9.09-9.484-4.768-11.139Z",
    transform: "translate(240.937 1697.961)",
    fill: "#630"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20087",
    "data-name": "Path 20087",
    d: "M1229.748,1011.306a9.6,9.6,0,0,1,3.866,3.459c3.2,4.863,17.756,37.661,17.756,37.661l-16.731,0-12.186-26.722c-.506-1.112-3.02-5.747-3.251-7.856-.747-6.79,4.893-9.134,10.546-6.54",
    transform: "translate(262.927 1745.479)",
    fill: "#092978",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20088",
    "data-name": "Path 20088",
    d: "M1280.4,895.518c-1.927,3.441,1.383,8.238,5.457,7.89l-.007,1.092-2.221,3.167,2.189,3.255,2.278.828,5.5-1.416v-9.912c.2-.063.208.3.618.049a4.586,4.586,0,0,0,1.15-3.042c-.165-.949-1.383-1.493-1.383-1.493h0c1.144-2.816,2.05-3.262-.9-4.827s-8.9-1.449-8.9-1.449l-2.7.905c-.117,2.619.247,2.568-1.09,4.953",
    transform: "translate(229.145 1812.606)",
    fill: "#f7cccf",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20089",
    "data-name": "Path 20089",
    d: "M1291.288,919.4a4.905,4.905,0,0,0,.6-.015,13.978,13.978,0,0,0,4.936-1.015,5.2,5.2,0,0,1-2.7,2.888,8.938,8.938,0,0,1-3.452.943l1.209-1.723.006-1.092Z",
    transform: "translate(223.116 1796.625)",
    fill: "#dd7577",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20090",
    "data-name": "Path 20090",
    d: "M1280.237,879.952c2.275.379,4.113.052,5.5.221a3.977,3.977,0,0,1,2,.955c1.3,1.055,2.317,3.659,2.61,5.385,0,0,1.526-.639,2.023-.322s.184,1.077.11,1.393-.779.654-1,.851c-.676.585.92.834,2.8-.684,5.734-4.628,2.776-13.048-4.312-15.46-3.444-1.172-3.038-2.559-5.409-3.06-8.608-1.678-11.066,8.593-4.328,10.721",
    transform: "translate(231.075 1824.076)",
    fill: "#363653",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20091",
    "data-name": "Path 20091",
    d: "M1256.055,929.7c-5.01,4.467-7.92,10.637-9.7,17.108,3.282-.214,6.714-.2,9.966-.3Z",
    transform: "translate(247.779 1790.319)",
    fill: "#f29900",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20092",
    "data-name": "Path 20092",
    d: "M1291.941,935.917a.6.6,0,1,1-.6.6.6.6,0,0,1,.6-.6m0-3.5a.6.6,0,1,1-.6.6A.6.6,0,0,1,1291.941,932.419Zm-2.327-9.3c-2.09,3.57.189,6.106,2.245,7.252,2.9-1.881,5.5-3.714,5.5-7.252,0,0,1-.019,1.648,1.568,1.071,2.57-.724,8.34-.724,8.34s-2.013-2.6-3.686-2.745a5.894,5.894,0,0,0-2.76.365c-2.141-1.57-3.6.465-5.032,1.957-.451-3.806-.393-6.542,2.454-9.486Z",
    transform: "translate(225.382 1793.983)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20093",
    "data-name": "Path 20093",
    d: "M1250.665,957.445H1222.47c-1.087,0-2.216.917-1.977,1.977l4.213,18.635c.24,1.06.89,1.977,1.976,1.977h28.2c1.087,0,2.216-.917,1.976-1.977l-4.212-18.635c-.24-1.061-.89-1.977-1.978-1.977",
    transform: "translate(262.189 1774.88)",
    fill: "#4895d1",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20094",
    "data-name": "Path 20094",
    d: "M1247.815,957.445H1219.62c-1.088,0-2.217.917-1.977,1.977l4.214,18.635c.24,1.06.89,1.977,1.977,1.977h28.194c1.088,0,2.217-.917,1.977-1.977l-4.213-18.635c-.24-1.061-.89-1.977-1.978-1.977",
    transform: "translate(263.776 1774.88)",
    fill: "#a3c5e8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20095",
    "data-name": "Path 20095",
    d: "M1256.011,978.656a1.977,1.977,0,1,0,2.138,1.355,1.8,1.8,0,0,0-2.138-1.355",
    transform: "translate(242.994 1763.112)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20096",
    "data-name": "Path 20096",
    d: "M1314.726,1004.219H1300.41v1.846h15.241v-.923a.926.926,0,0,0-.924-.923",
    transform: "translate(217.696 1748.849)",
    fill: "#4895d1",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20097",
    "data-name": "Path 20097",
    d: "M443.124,418.777a4.824,4.824,0,0,1,6.811,0l.005,0a4.824,4.824,0,0,1-.005,6.812v.006a4.821,4.821,0,0,1-6.817-6.818Zm3.405-4.1a7.479,7.479,0,0,0-5.3,2.2l0,0a7.5,7.5,0,1,0,10.6,10.6l0,0a7.493,7.493,0,0,0,0-10.6l0,0,0,0A7.482,7.482,0,0,0,446.53,414.681Z",
    transform: "translate(697.079 2076.944)",
    fill: "#f18e00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20098",
    "data-name": "Path 20098",
    d: "M625.493,419.965h0a1.21,1.21,0,0,0-1.207,1.208v10.555a1.21,1.21,0,0,0,1.207,1.208h0a1.21,1.21,0,0,0,1.207-1.208V421.172a1.21,1.21,0,0,0-1.207-1.208",
    transform: "translate(593.978 2074.003)",
    fill: "#219ef8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20099",
    "data-name": "Path 20099",
    d: "M612.385,433.073h0a1.21,1.21,0,0,0,1.207,1.207h10.555a1.21,1.21,0,0,0,1.207-1.207h0a1.211,1.211,0,0,0-1.207-1.208H613.592a1.211,1.211,0,0,0-1.207,1.208",
    transform: "translate(600.601 2067.381)",
    fill: "#219ef8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20100",
    "data-name": "Path 20100",
    d: "M866.479,421.782a3.409,3.409,0,0,1,4.816,0l0,0a3.41,3.41,0,0,1,0,4.816v0a3.408,3.408,0,0,1-4.82-4.819Zm2.408-2.9a5.289,5.289,0,0,0-3.751,1.554l0,0a5.3,5.3,0,1,0,7.5,7.5l0,0a5.3,5.3,0,0,0,0-7.5l0,0,0,0A5.289,5.289,0,0,0,868.887,418.886Z",
    transform: "translate(460.803 2074.604)",
    fill: "#f18e00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20101",
    "data-name": "Path 20101",
    d: "M1190.226,361.245h0a1.592,1.592,0,0,0-1.587,1.587v5.351h-5.351a1.591,1.591,0,0,0-1.587,1.587h0a1.591,1.591,0,0,0,1.587,1.587h5.351v5.351a1.592,1.592,0,0,0,1.587,1.587h0a1.592,1.592,0,0,0,1.587-1.587v-5.351h5.35a1.591,1.591,0,0,0,1.587-1.587h0a1.591,1.591,0,0,0-1.587-1.587h-5.35v-5.351a1.592,1.592,0,0,0-1.587-1.587",
    transform: "translate(283.76 2106.683)",
    fill: "#219ef8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20102",
    "data-name": "Path 20102",
    d: "M982.549,351.526h0a1.389,1.389,0,0,0-1.385,1.385v12.11a1.389,1.389,0,0,0,1.385,1.385h0a1.389,1.389,0,0,0,1.385-1.385v-12.11a1.389,1.389,0,0,0-1.385-1.385",
    transform: "translate(395.365 2112.092)",
    fill: "#219ef8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20103",
    "data-name": "Path 20103",
    d: "M967.51,366.565h0a1.388,1.388,0,0,0,1.385,1.384H981a1.388,1.388,0,0,0,1.385-1.384h0A1.388,1.388,0,0,0,981,365.182H968.9a1.388,1.388,0,0,0-1.385,1.383",
    transform: "translate(402.964 2104.492)",
    fill: "#219ef8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20104",
    "data-name": "Path 20104",
    d: "M754.31,342.955a4.824,4.824,0,0,1,6.812,0l.005,0a4.824,4.824,0,0,1-.005,6.812v0a4.82,4.82,0,0,1-6.817-6.817Zm3.406-4.1a7.479,7.479,0,0,0-5.3,2.2l0,0a7.5,7.5,0,1,0,10.6,10.6l0,0a7.495,7.495,0,0,0,0-10.6l0,0,0,0A7.48,7.48,0,0,0,757.717,338.859Z",
    transform: "translate(523.895 2119.141)",
    fill: "#f18e00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20105",
    "data-name": "Path 20105",
    d: "M1365.511,412.868a3.409,3.409,0,0,1,4.816,0l0,0a3.41,3.41,0,0,1,0,4.815v0a3.408,3.408,0,0,1-4.819-4.819Zm2.408-2.9a5.285,5.285,0,0,0-3.751,1.553l0,0a5.3,5.3,0,1,0,7.5,7.5l0,0a5.3,5.3,0,0,0,0-7.5h0l0,0A5.287,5.287,0,0,0,1367.92,409.972Z",
    transform: "translate(183.077 2079.565)",
    fill: "#f18e00"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFds1);
export default __webpack_public_path__ + "static/media/fds1.a3148f7a313f83581e24f241c05537c7.svg";
export { ForwardRef as ReactComponent };